export default "__VITE_ASSET__DEqTtN5t__"